import React, { ReactNode, Dispatch, SetStateAction } from "react";
import { Box, Flex, Stack, Text } from "@chakra-ui/react";
import { SmileSignUpSteps } from "../..";
import SmileSignupLeftView from "../Views/PixSignupLeftView";
import SmileSignupBreadcrumbs from "../Controls/SmileSignupBreadcrumbs";
import { IS_HYBRIDGE } from "src/modules/smile/shared/consts";
import * as consts from "src/shared/consts";

const SmileSignupPageLayout = ({
  children,
  stepTitle,
  step,
  setStep,
}: {
  step: SmileSignUpSteps;
  children: ReactNode;
  stepTitle: string;
  setStep: Dispatch<SetStateAction<SmileSignUpSteps>>;
}) => {
  return (
    <Flex
      w={{ sm: "100vw" }}
      h={{ sm: "100vh" }}
      flexDirection={{ base: "column", sm: "row" }}
      bg={
        IS_HYBRIDGE
          ? "white"
          : "linear-gradient(180deg, #F1FEFF -0.63%, #EDF7FF 22.95%, #FDFDFF 48.11%, #ECF6FF 69.08%, #FFFCFE 85.85%, #E7F3FF 100%)"
      }
      pos={"relative"}
    >
      {IS_HYBRIDGE ? null : (
        <Box pos={"absolute"} inset={0} overflow={"hidden"} zIndex={0}>
          <Box
            display={{ base: "block", sm: "none" }}
            position={"absolute"}
            left={"-250px"}
            top={"-250px"}
            width={"200%"}
            pt={"175%"}
            borderRadius={"50%"}
            bg={"linear-gradient(109.91deg, #FC2C54 16.04%, #FFA7DC 75%)"}
            style={{
              filter: "blur(70px)",
            }}
          />
          <Box
            display={{ base: "none", sm: "block" }}
            position={"absolute"}
            left={0}
            top={"50%"}
            width={"50%"}
            pt={"50%"}
            transform={"translate(-10%, -50%)"}
            borderRadius={"50%"}
            bg={"linear-gradient(109.91deg, #FC2C54 16.04%, #FFA7DC 75%)"}
            style={{
              filter: "blur(70px)",
            }}
          />
        </Box>
      )}
      <Flex w={{ sm: "57vw" }} h={{ sm: "100%" }} zIndex={1} bg={IS_HYBRIDGE ? consts.COLOR_RED : undefined}>
        <SmileSignupLeftView step={step} />
      </Flex>
      <Flex
        w={{ sm: "43vw" }}
        px={{ base: "16px", md: "100px" }}
        pt={{ base: "40px", sm: "15px" }}
        pb={{ base: "65px", sm: "unset" }}
        direction="column"
        zIndex={1}
      >
        <SmileSignupBreadcrumbs step={step} setStep={setStep} />
        <Stack as="main" spacing="50px">
          {step !== 2 && (
            <Text
              mt={{ base: "45px", sm: "100px" }}
              fontFamily="Montserrat"
              fontStyle="normal"
              fontWeight="600"
              fontSize={{ base: "48px", sm: "40px" }}
              lineHeight="100%"
              letterSpacing="-0.03em"
            >
              {stepTitle}
            </Text>
          )}
          {children}
        </Stack>
      </Flex>
    </Flex>
  );
};

export default SmileSignupPageLayout;
